module.exports = __webpack_public_path__ + "img/D201709_3.102766fb.jpg";